<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>外接IPC</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="action-wrapper">
         <el-button type="primary" @click="clickBatchUpdate">批量更新固件包</el-button>
      </div>

      <div class="content-wrapper">
         <el-table :data="dataList" ref="multipleTable" @selection-change="selectioncChanged">
            <el-table-column align="center" type="selection" width="55" fixed></el-table-column>
            <el-table-column align="center" label="名称" prop="deviceName"></el-table-column>
            <el-table-column align="center" label="型号" prop="deviceType"></el-table-column>
            <el-table-column align="center" label="IP地址" prop="ipAddress"></el-table-column>
            <el-table-column align="center" label="当前版本" prop="versionCode"> </el-table-column>
            <el-table-column align="center" label="更新日期" prop="updateTime"></el-table-column>
            <el-table-column align="center" label="最近配置的更新" prop="lastVersionCode"></el-table-column>
            <el-table-column align="center" label="操作" width="220">
               <template scope="{ row }">
                  <el-button type="text" @click="clickUpdate(row)">更新</el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <el-dialog :title="updateDialog.title" destroy-on-close v-model="updateDialog.visible"
         :close-on-click-modal="false" :modal-append-to-body="false">
         <el-form label-width="100px">
            <el-form-item label="选择固件版本:">
               <el-select v-model="updateDialog.selectId" placeholder="请选择固件版本" filterable style="width: 100%;">
                  <el-option v-for="(item, index) in updateDialog.data" :key="index" :label="item.label"
                     :value="item.value">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="版本描述内容:">
               <div>{{ updateDialog.content[updateDialog.selectId] }}</div>
            </el-form-item>
         </el-form>
         <template #footer>
            <el-button @click="updateDialog.visible = false">取消</el-button>
            <el-button type="primary" @click="clickUpdateDone">确认</el-button>
         </template>
      </el-dialog>
   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         queryParam: {
            uid: '',
            deviceType: '超脑ipc',
         },
         dataList: [1],
         selections: [],
         updateDialog: {
            visible: false,
            title: '',
            uids: [],
            uid: '',
            deviceName: '',
            data: [],
            content: {},
            selectId: 0,
         },
      }
   },

   mounted() {
      this.queryParam.uid = this.$util.getUrlParam("uid");
      this.queryList();
   },

   methods: {
      // 查询外接IPC列表
      queryList() {
         this.loading = true;
         this.$http({
            url: this.$util.aioIP + '/api/m/hw/onePc/v310/ipc/list',
            method: 'get',
            headers: { channelCode: this.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj' },
            params: this.queryParam,
         }).then((result) => {
            if (!result.data.data || JSON.stringify(result.data.data) === '[]') {
               this.dataList = [];
               return;
            }
            this.dataList = result.data.data || [];
         }).catch(() => {
            this.dataList = [];
         }).finally(() => {
            this.loading = false;
         });
      },
      // 查询批量固件包版本列表
      queryBatchFirmwareList() {
         this.loading = true;
         let params = {
            uids: this.updateDialog.uids,
            deviceType: 'IPC',
         }
         this.$http({
            method: 'post',
            url: this.$util.aioIP + '/api/m/sys/appUpgrade/v290/batchList',
            body: params,
         }).then((result) => {
            if (!result.body.data || JSON.stringify(result.body.data) === '[]') {
               this.updateDialog.data = []
               this.updateDialog.selectId = 0
               this.$util.errorMsg('暂未查询到固件版本')
               return
            }
            this.updateDialog.data = result.body.data.map((item) => {
               this.updateDialog.content[item.id] = item.content
               return {
                  label: item.versionCode,
                  value: item.id,
               }
            })
            this.updateDialog.selectId = this.updateDialog.data[0].value
            this.updateDialog.visible = true
         }).catch(() => {
            this.updateDialog.data = []
            this.updateDialog.selectId = 0
            this.$util.errorMsg('查询固件版本失败')
         }).finally(() => {
            this.loading = false;
         })
      },
      // 查询固件包版本列表
      queryFirmwareList() {
         this.loading = true;
         let params = {
            uid: this.updateDialog.uid,
            deviceType: 'IPC',
         }
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/sys/appUpgrade/v210/list',
            params: params,
         }).then((result) => {
            if (!result.body.data || JSON.stringify(result.body.data) === '[]') {
               this.updateDialog.data = []
               this.updateDialog.selectId = 0
               this.$util.errorMsg('暂未查询到固件版本')
               return
            }
            this.updateDialog.data = result.body.data.map((item) => {
               this.updateDialog.content[item.id] = item.content
               return {
                  label: item.versionCode,
                  value: item.id,
               }
            })
            this.updateDialog.selectId = this.updateDialog.data[0].value
            this.updateDialog.visible = true
         }).catch(() => {
            this.updateDialog.data = []
            this.updateDialog.selectId = 0
            this.$util.errorMsg('查询固件版本失败')
         }).finally(() => {
            this.loading = false;
         })
      },
      // 发送批量更新固件包版本
      sendBatchUpdateFirmware() {
         this.loading = true;
         let deviceNames = this.selections.map((item) => item.deviceName || '')
         let param = {
            uids: this.updateDialog.uids,
            deviceNames: deviceNames,
            deviceType: 'IPC',
            appUpgradeId: this.updateDialog.selectId
         }
         this.$http({
            method: 'post',
            url: this.$util.aioIP + '/api/m/sys/appUpgrade/v290/batchUpdate',
            body: param,
         }).then((result) => {
            if (result.body.data === true) {
               this.updateDialog.visible = false;
               this.$util.successMsg('更新成功');
               this.queryList();
            } else {
               this.$util.errorMsg(result.body.msg);
            }
         }).catch(() => {
            this.updateDialog.visible = false;
            this.$util.errorMsg('更新失败');
         }).finally(() => {
            this.loading = false;
         })
      },
      // 发送更新固件包版本
      sendUpdateFirmware() {
         this.loading = true;
         let param = {
            uid: this.updateDialog.uid,
            deviceType: this.updateDialog.deviceName,
            deviceName: this.updateDialog.deviceName,
            appUpgradeId: this.updateDialog.selectId
         }
         this.$http({
            method: 'post',
            url: this.$util.aioIP + '/api/m/sys/appUpgrade/v210/update',
            body: param,
         }).then((result) => {
            if (result.body.data === true) {
               this.updateDialog.visible = false;
               this.$util.successMsg('更新成功');
               this.queryList();
            } else {
               this.$util.errorMsg(result.body.msg);
            }
         }).catch(() => {
            this.updateDialog.visible = false;
            this.$util.errorMsg('更新失败');
         }).finally(() => {
            this.loading = false;
         })
      },
      // 点击批量更新固件包
      clickBatchUpdate() {
         if (!this.selections || this.selections.length == 0) {
            this.$message.error('请选择外接IPC');
            return;
         }
         this.updateDialog.title = '批量设备更新';
         this.updateDialog.uids = [this.queryParam.uid];
         this.updateDialog.uid = '';
         this.updateDialog.deviceName = '批量';
         this.queryBatchFirmwareList();
      },
      // 点击选中
      selectioncChanged(selections) {
         this.selections = selections;
      },
      // 点击单个更新
      clickUpdate(row) {
         this.updateDialog.title = '设备更新';
         this.updateDialog.uids = [];
         this.updateDialog.uid = row.uid;
         this.updateDialog.deviceName = row.deviceName || '';
         this.queryFirmwareList();
      },
      // 点击更新弹框确认按钮
      clickUpdateDone() {
         if (this.updateDialog.uids.length) {
            this.sendBatchUpdateFirmware();
         } else {
            this.sendUpdateFirmware();
         }
      }
   }
}
</script>


// WEBPACK FOOTER //
// EquipmentBoxBrain.vue?e73b8c3e